<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import MainTabSystem from '../components/MainTabSystem.vue';
import NavBar from '../components/NavBar.vue';
import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore()
const router = useRouter()

const logout = () => {
  localStorage.removeItem('token')
  router.push('/login')
}


</script>



<template>
  <div class="app-wrapper d-flex flex-column min-vh-100">
    <NavBar />
    <main class="flex-grow-1 py-4">
      <div class="mainContainer">
        <div class="welcome-banner">
          <div class="welcome-icon">
            <i class="bi bi-star-fill"></i>
          </div>
          <div class="welcome-content">
            <h2 class="welcome-title">Welcome to WASPL Editor</h2>
            <p class="welcome-text">
              The ideal platform to design and manage complete assessment processes.
              For more information, project updates, support, and networking opportunities, visit
              <a class="welcome-link" target="_blank" href="https://waspl.wiquid.fr/">waspl.wiquid.fr</a>
            </p>
          </div>
        </div>
        <div class="tabContainer">
          <MainTabSystem />
        </div>
      </div>
    </main>

    <footer class="bg-dark text-white py-3 mt-auto">
      <div class="container text-center">
        <p class="mb-0">Wiquid Copyright © 2025</p>
      </div>
    </footer>
  </div>
</template>

<style scoped>
h1 {
  color: #333;
  font-size: 1.5rem;
  
}

.tabContainer{
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  
}

.dashboard {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
 
}
.DashModule {
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
}



</style>

<style>
.tabulator {
  background-color: transparent !important;
}

.card-preview {
  background-color: rgb(243, 243, 243);
}

.dashbordBlock {
    text-align: left;
    margin-bottom: 0.5rem;
    color: #333;
    font-weight: bold;
    font-size: 1.5rem;

}

.infos{
  height:350px;
  overflow-y: scroll;
}

/* Welcome banner - modern design */
.welcome-banner {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: linear-gradient(135deg, #E3F2FD 0%, #F3E5F5 100%);
  border-left: 5px solid #1976D2;
  border-radius: 12px;
  padding: 24px;
  margin: 0 0 30px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.welcome-banner:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.welcome-icon {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #1976D2 0%, #7B1FA2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.25);
}

.welcome-content {
  flex: 1;
}

.welcome-title {
  margin: 0 0 8px 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1565C0;
  background: linear-gradient(135deg, #1976D2 0%, #7B1FA2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-text {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #424242;
}

.welcome-link {
  color: #1976D2;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.welcome-link:hover {
  color: #7B1FA2;
  border-bottom-color: #7B1FA2;
}

/* Responsive design */
@media (max-width: 768px) {
  .welcome-banner {
    flex-direction: column;
    padding: 20px;
    gap: 16px;
  }

  .welcome-icon {
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
  }

  .welcome-title {
    font-size: 1.3rem;
  }

  .welcome-text {
    font-size: 0.95rem;
  }
}

@media (max-width: 576px) {
  .welcome-banner {
    padding: 16px;
  }

  .welcome-title {
    font-size: 1.2rem;
  }

  .welcome-text {
    font-size: 0.9rem;
  }
}
</style>

